import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { ShipmentTrackerStatusBadge } from "../../common/shipment-tracker-status-badge";

const catalogEntry = fgColumnEntries.returnTrackingStatus;

export const ReturnTrackingStatusColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  width: catalogEntry.defaultWidth,
  renderNormalCell: ({ row }) => {
    if (!row.returnTrackingStatus?.length) {
      return null;
    }
    return (
      <Flex align="center" gap="sm" pl="lg">
        {row.returnTrackingStatus.map((status, index) => (
          <ShipmentTrackerStatusBadge
            key={index}
            shipmentTrackerStatus={status}
          />
        ))}
      </Flex>
    );
  },
  alignment: ColumnAlignment.LEFT,
};
